$(function () {
    $('input.search-filter-param').change(function () {
        //console.log(makeUrl());
        window.location.href = makeUrl();
    });
});

function makeUrl() {
    let params = {
        types: makeTypeString(),
        visibility: makeVisibilityString(),
        when: whenChecked()
    }

    let querystring = Object.keys(params).map(key => key + '=' + params[key]).join('&');

    return '/events?' + querystring;
}

function makeTypeString() {
    let checkedValues = [];

    $('input[name="types"]').each(function () {
        if ($(this).prop('checked')) {
            checkedValues.push($(this).val());
        }
    });

    return Object.keys(checkedValues).map(key => checkedValues[key]).join(',');
}

function makeVisibilityString() {
    let checkedValues = [];

    $('input[name="visibility"]').each(function () {
        if ($(this).prop('checked')) {
            checkedValues.push($(this).val());
        }
    });

    return Object.keys(checkedValues).map(key => checkedValues[key]).join(',');
}

function whenChecked() {
    let value = '';
    $('input[name="when"]').each(function () {
        if ($(this).prop('checked')) {
            value = $(this).val();
        }
    });
    return value;
}